/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import { Fab, Grid, Paper, Typography } from '@material-ui/core';
import { MuiThemeProvider, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { Info, Oauth2Service, obiektService, RodzPokoiInfo, roomsService, webRoom, Result, hotelService } from './api';
import RoomPanel from './app/RoomPanel';
import RoomPanelMini2 from './app/centerPanelMini2/RoomPanel';
import CenterPanel from './app/centerPanel/CenterPanel';
import CenterPanelMini from './app/centerPanelMini/CenterPanel';
import CenterPanelMini2 from './app/centerPanelMini2/CenterPanel';
import CenterRight from './app/centerPanel/CenterRight';
import CenterRightMini2 from './app/centerPanelMini2/CenterRight';
import CookiesFooter from './app/common/CookiesFooter';
import DialogError from './app/common/DialogError';
import { daysFromDate, sendErrorLog, themeExist, themeSelect, selectTheme } from './app/common/helpers';
import OknoPrzerwa from './app/common/OknoPrzerwa';
import MapContainer from './app/map/MapContainer';
import PanelRight from './app/rightPanel/PanelRight';
import Failure from './app/payment/Failure';
import Success from './app/payment/Success';
import { Actions, AppState, store, ZapisanyFormularz, IPageState } from './appredux';
import CONFIG, { window2config } from './cfg/config';
import { fontSelect } from './fonts';
import theme, { ThemeOrange } from './themes/themes';
import ResponsiveImgMaterialUi from 'responsive-img-material-ui';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';
import { getDataFromSessionStorage } from 'app/common/helpersOAuth';

import { MapData } from 'app/map/MapContainer';
import { gpsToNumber } from 'app/map/Distance';
import LogoFooter from 'app/common/LogoFooter';
import ZarzadzajRezerwacja from 'app/manageReservation/ZarzadzajRezerwacja';
import StartNawigacja from 'app/centerPanelMini/StartNawigacja';
import Klawiatura from 'app/common/Klawiatura';

///////////////////////////////////////////////////////
export const GRAFIK_DNI = 21  // +1 
///////////////////////////////////////////////////////

// const FabTheme = createTheme({
//   palette: {
//     primary: {
//       main: "#5F9EA0",
//       dark: "#347173"
//     },
//   },
// });


//const Logo = require('./img/logo.png');

/*
import Projekt  from './projekt2'
const test = true;
if (test) 
    return(<Projekt />)
else
*/


//PM 2021-10-29
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface AppProps extends  WithTranslation, WithStyles<typeof styles>  {
  page: IPageState,
  lang: string,
  dateFrom: string,
  showMap: number,
  notifierOpen: number,
  rezerwacjaAnuluj: number,
}

//PM 2021-10-29
//cookiesZaakceptowane: boolean
interface AppStateInterface {
  info: Info,
  error: boolean,
  loading: boolean,
  windowWidth: number,
  expand: boolean,
  panel: number,

  openSuccess: boolean,
  openFailure: boolean,
  cookiesZaakceptowane: boolean,

  openZarzadzaj: boolean,
  nrTelefonu: string,
  nrRezerwacji: string,
}

let selectedTheme: Theme;

class App extends React.Component<AppProps, AppStateInterface> {

  refreshTimeout: any;
  //PM 2021-10-29
  //(props: AppProps & WithStyles<typeof styles>)
  //cookiesZaakceptowane: cookiesZaakceptowane ? true : false
  constructor(props: AppProps) {
    super(props, {});
    window2config();
    const cookiesZaakceptowane = localStorage.getItem('cookies_zaakceptowane')
    //localStorage.setItem("rezerwacja", "11251:+48501417198" )

    sessionStorage.setItem('operator_id', "1");

    //store.dispatch(Actions.pageState.setGrafikMaxiMini(CONFIG.grafikMaxiMini === "1" ? 1 : CONFIG.grafikMaxiMini === "2" ? 2 : 0))

    let telefon: string = ""
    let rezId: string = ""
    let open: boolean = false
    if (this.props.rezerwacjaAnuluj == 0 && CONFIG.rezNr != "" && CONFIG.telNr != "") {
      telefon = CONFIG.telNr
      rezId = CONFIG.rezNr
      open = true
      store.dispatch(Actions.pageState.setFirstOpen())
    } else if (this.props.rezerwacjaAnuluj == 0 && localStorage.getItem("rezerwacja")) {
      let rezerwacja = localStorage.getItem("rezerwacja")!.split(":")
      rezId = rezerwacja[0]
      telefon = rezerwacja[1].replace("+", "")
      open = true
      localStorage.removeItem("rezerwacja")  
      store.dispatch(Actions.pageState.setFirstOpen())
    }

    this.state = {
      info: new Info(),
      error: false,
      loading: true,
      windowWidth: window.innerWidth,
      expand: true,
      panel: 0,

      openSuccess: CONFIG.stanPlatnosci === "sukces" ? true : false,
      openFailure: CONFIG.stanPlatnosci === "porazka" ? true : false,
      cookiesZaakceptowane: cookiesZaakceptowane || CONFIG.hotelKiosk === "1" ? true : false,

      openZarzadzaj: open,
      nrTelefonu: telefon,
      nrRezerwacji: rezId,
    }

    const title = document.getElementsByTagName("title")[0];

    //let text = CONFIG.hotelID.split(" ").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1).toLowerCase()).join(" ")
    //text = text.split("-").map((current: string) => current.charAt(0).toUpperCase() + current.slice(1)).join("-")
    let text = CONFIG.hotelID
    title.innerText = 'Bookuj (z) Virtual\xA0\xA0\xA0' + text
    //title.innerText = "Rezerwacje " + text

    window.onbeforeunload = function () {
      sendErrorLog("1", "1", 'stop aplikacji')

    };

    /////////////////////////////////////////////////////////////
    //okna z pytaniem przed zamknięciem
    if(CONFIG.hotelKiosk !== "1"){
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
      });
      window.onbeforeunload = () => {
      };
    } 
    /////////////////////////////////////////////////////////////
  }

 
  //PM 2021-11-15
  //await this.getDataFromSessionStorage()
  async componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    await sendErrorLog("1", "1", "start aplikacji")
    await store.dispatch(Actions.pageState.addFcmLogMessage("start aplikacji", 0))

    if (CONFIG.przerwa !== "1") {
      await this.dajSerwerWersja()
      await getDataFromSessionStorage()
      await this.getPortalInfo()
      await this.getRoomsData(true)
      this.click()
    }
  }

  //PM 2021-10-29
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  //(prevProps: AppProps & WithStyles<typeof styles>)
  componentDidUpdate(prevProps: AppProps & WithStyles<typeof styles>) {
    if (prevProps.lang !== this.props.lang) {
      this.getPortalInfo();
      this.getRoomsData()
    }
    if (this.props.dateFrom !== prevProps.dateFrom) {
      this.getRoomsData()
    }
    if (this.props.showMap !== prevProps.showMap) {
      this.setState({ panel: 1 })
    }

    /////////////////////////////
    if (prevProps.notifierOpen !== this.props.notifierOpen)
      this.setZarzadzajClosed();

      let openRes = this.props.page.openRezerwacjaZarzadzaj
    if(openRes.tel !== "" && openRes.nr !== 0 && openRes.open !== prevProps.page.openRezerwacjaZarzadzaj.open ) {
      this.setState({openZarzadzaj: true, nrTelefonu: openRes.tel, nrRezerwacji: openRes.nr.toString()})
    }
  }

  //PM 2021-07-28
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  //SW 2021-08-27
  closeWindows = () => {
    this.setState({ openSuccess: false, openFailure: false })
  }

  setZarzadzajOpen = () => {
    this.setState({ openZarzadzaj: true });
  }

  setZarzadzajClosed = () => {
    this.setState({ openZarzadzaj: false });
  }


  //PM 2021-10-29
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async getPortalInfo() {
    try {
      let res: Info = await obiektService.dajPortalInfo({
        hotelId: CONFIG.hotelID,
        //operatorId: Number(sessionStorage.getItem("operator_id")),
        domena: this.props.lang
      }, {})

      // let resManager = await hotelService.getPortalInfo({
      //   hotelId: CONFIG.hotelID,
      //   operatorId: Number(sessionStorage.getItem("operator_id")),
      //   domena: this.props.lang
      // }, {})
      // await store.dispatch(Actions.pageState.setContactManager(resManager.result[0]));
      if(!res || (!res.kontaktTelefon && !res.kontaktEmail && !res.kontaktAdres) ){
        throw "brak danych"
      }
 
      if (!res.materialuiZestawNr) {
        res.materialuiZestawNr = "1"
      }

      this.setState({ info: res});
      //res.result[0].materialui_zestaw_nr = "1"
      //store.dispatch(Actions.pageState.setTheme(res.result[0].materialui_zestaw_nr));  

      //contact.payWeb wzięte z /manager/recepcjaDajWwwPortalInfo0
      //0 - brak
      //1 - CashBill
      //4 - Przelewy24
      //5 - TPay

      //aktualne
      //0/1/2/3
      //brak/P24/CashBill/SmsKod

      //pay = "4"

      let preauto = 0
      if(res.preautoryzacja === "T" || res.preautoryzacja === "t" || res.preautoryzacja === "1"){
        preauto = 1
      }
      await store.dispatch(Actions.pageState.setPreautoryzacja(preauto))

      //res.materialuiZestawNr = "3"
      await store.dispatch(Actions.pageState.setContact(
        //{...res, payWeb: "5"},
        res,
        selectedTheme.palette.secondary.light,
        selectedTheme.palette.text.secondary,
      ));

      let gpsReturn = gpsToNumber(res.kontaktGps);
      let latNumber = gpsReturn.lat;
      let lngNumber = gpsReturn.lng;
      let d = new MapData({ obiektGPS: res.kontaktGps, obiektLat: latNumber, obiektLng: lngNumber })
      store.dispatch(Actions.pageState.setMap(d));

    } catch (error) {
      //await sendErrorLog(CONFIG.hotelID, '301', "0", "-1", String(error))
      await sendErrorLog("0", "-1", '/obiekt/dajPortalInfo')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajPortalInfo", 2))
      console.log(error)
      this.setState({ ...this.state, error: true, loading: false });
    }
  }

  async dajSerwerWersja() {
    try {
       
          let res = await hotelService.dajSerwerWersja(
            {
              hotelId: CONFIG.hotelID,            
            }
          ) 

        if (res.result.length) {
          await store.dispatch(Actions.pageState.setSerwerWersja(res.result));
        }
        
      
    } catch (error) {
      await sendErrorLog("0", "-1", 'manager/dajSerwerWersja')
      await store.dispatch(Actions.pageState.addFcmLogMessage("manager/dajSerwerWersja", 2))
      console.log(error)
      this.setState({ error: true, loading: false });
    }
  }

  //PM 2021-10-29
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async getRoomsData(ladowanie: boolean = false) {
    try {
      if(ladowanie){  this.setState({ loading: true }); }

      if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3") {
        let res: Result<webRoom>

        if(this.props.page.podstrona){

         
          if(this.props.page.serwerWersja >= 5){ //nowe
            res = await roomsService.getRoomsSubpage2(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
                aPodstronaNr: this.props.page.podstrona,
                aDataOd: this.props.dateFrom,
                aDataDo: daysFromDate(new Date(this.props.dateFrom), 1)
              }
            ) 
          } else { //stare
            res = await roomsService.getRoomsSubpage(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
                aPodstronaNr: this.props.page.podstrona
              }
            ) 
          }

        } else {


          if(this.props.page.serwerWersja >= 5){ //nowe
            res = await roomsService.getRooms2(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.lang,
                aDataOd: this.props.dateFrom,
                aDataDo: daysFromDate(new Date(this.props.dateFrom), 1)
              }
            )
          } else { //stare
            res = await roomsService.getRooms(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.lang
              }
            )
          }


        }
      

        if (res.result.length === 0) {
          throw "brak danych"
        } else {
          this.setState({ loading: false })
        }
        await store.dispatch(Actions.pageState.updateRoomsOld(res.result));


        let podstrona = res.result.find(x => x.rodz_pokoi === this.props.page.roomBlink)
        if (this.props.page.ustawPodstrona && podstrona && this.props.page.podstrona === 0 && CONFIG.rodzPokoiPodstrona === "1" && this.props.page.roomBlink !== "") {
          setTimeout(() => {
            store.dispatch(Actions.pageState.setPodstrona(podstrona.podstrona_nr));
          }, 500);
          
        }

      }
      else {
        const res = await obiektService.dajRodzPokoiInfo1({
          hotelId: CONFIG.hotelID,
          domena: this.props.lang,
          dataOd: this.props.dateFrom,
          dataDo: daysFromDate(new Date(this.props.dateFrom), 1)
        })

        if (res.result.length === 0) {
          throw "brak danych"
        } else {
          this.setState({ loading: false })
        }

        let storeRooms: RodzPokoiInfo[] = [];

        for (const room1 of res.result) {
          storeRooms.push({ ...room1 });
        }

        await store.dispatch(Actions.pageState.updateRooms(storeRooms));
      }
    } catch (error) {
      await sendErrorLog("0", "-1", '/manager/recepcjaDajWwwRodzajePokoiInfo1')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaDajWwwRodzajePokoiInfo1", 2))
      console.log(error)
      this.setState({ error: true, loading: false });
    }
  }

  expand = () => {
    this.setState({ expand: !this.state.expand })
  }

  setPanel = (panel: number) => {
    this.setState({ panel: panel })
  }


  openMap = () => {
    let split = this.props.page.contact.kontaktGps.split(" ")
    if(split.length > 1){
      let lon = split[0].substring(0, split[0].length -1)
      let lat = split[1].substring(0, split[1].length -1)
      let link = `http://maps.google.com/maps?q=&layer=c&cbll=${lon},${lat}`
      window.open(link)
    }
  }

  click = () => {
    clearInterval(this.refreshTimeout)
    if(CONFIG.hotelKiosk === "1" ){ //this.props.page.czyTimer
      this.refreshTimeout = setTimeout(() => {
        window.location.reload()
      }, 1000*60*5); //5min
    }
  }

  //PM 2021-11-08
  //const logoUrl
  //poprawka DOM
  render() {
    const { classes } = this.props;
    const tloUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/tlo.png`;
    const logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/startowe.jpg` || '';


    selectedTheme = selectTheme(this.state.info.materialuiZestawNr)

    let textTheme = fontSelect(3, 2) as React.CSSProperties;
    let color = ""
    if (textTheme && Object.keys(textTheme).length !== 0) {
      color = textTheme.color as string
    }

    if (CONFIG.przerwa === "1")
      return (
        <MuiThemeProvider theme={selectedTheme}>
          <OknoPrzerwa />
        </MuiThemeProvider>
      )
    else return (
      <React.Fragment>
        <div onClick={this.click} className={classes.root} style={{ background: `url(${tloUrl})`, paddingTop: '4.8px', scrollbarColor: "#ddd #fff" }}>

          <MuiThemeProvider theme={selectedTheme}>
            {this.state.loading ?
              <DialogError error={false} logoUrl={logoUrl} />
              : this.state.error ?
                <DialogError error={true} logoUrl={logoUrl} />
                : this.props.page.rooms.length > 0 || this.props.page.roomsOld.length > 0 ?


            

                <Grid container style={{ paddingLeft: this.state.windowWidth > 1200 ? '7px' : '2px' }}>
                    {this.state.panel === 1 ?

                      <Grid
                        item
                        style={{ padding: '12px 14px', width: "100%", }}
                      >
                        <Paper id="graphic" className={classes.paper} elevation={0} >
                          <MapContainer />
                        </Paper>
                      </Grid>

                      : 
                      this.props.page.grafikMaxiMini === 0 ? 
                      < React.Fragment >
 
                    <Grid
                      item
                      style={{ width: this.state.windowWidth > 599 ? "216px" : '100%', padding: this.state.windowWidth > 599 ? '8px 0px 0px 4px' : "8px 8px 0px 8px" }}
                      className={classes.positionRelative}
                    >
                      <Paper id="nav" className={classes.paperNav} elevation={6} >
                        {themeExist(color) ?
                          <MuiThemeProvider theme={themeSelect(color)}>
                            <CenterRight windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} />
                          </MuiThemeProvider>
                          :
                          <CenterRight windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} />
                        }
                      </Paper>
                    </Grid>


                  <Grid
                    container spacing={2}
                    className={classes.container}
                    style={{ width: this.state.windowWidth > 599 ? "calc(100% + -216px)" : "100%", paddingTop: '' }}
                  >
                    <Grid
                      item xs={12} sm={9}
                      className={classes.orderCenter}
                      style={{ paddingLeft: this.state.windowWidth > 599 ? "10px" : "10px", paddingRight: this.state.windowWidth > 599 ? "8px" : "10px" }}
                    >
                      <Paper id="graphic" className={classes.paper} elevation={0} >
                        <CenterPanel expanded={this.state.expand} expand={this.expand} windowWidth={this.state.windowWidth}/>
                      </Paper>
                    </Grid>


                    {this.state.windowWidth > 599 ?
                      (
                        <Grid item xs={12} sm={3} style={{ order: 5, height: "50px" }}>
                          <PanelRight setZarzadzajOpen={this.setZarzadzajOpen} />
                        </Grid>
                      ) : null}

                  </Grid>

                      <Grid item className={classes.orderBottom} style={this.state.windowWidth > 599 ? { padding: '8px 8px 8px 15px', width: "calc(100% - (100% + -216px)* 0.25)" } : { paddingLeft: "10px", width: "100%", paddingRight: "10px" }}>
                        <RoomPanel windowWidth={this.state.windowWidth} />
                        {this.state.windowWidth > 599 ?
                         <LogoFooter/> : null}
                      </Grid>

                  {this.state.windowWidth <= 599 ?
                      (
                        <Grid item xs={12} sm={3} style={{ order: 10, height: "50px" }}>
                          <PanelRight setZarzadzajOpen={this.setZarzadzajOpen} />
                          <LogoFooter />
                        </Grid>
                      ) : null}
                    <Success open={this.state.openSuccess} handleModalClose={this.closeWindows} />
                    <Failure open={this.state.openFailure} handleModalClose={this.closeWindows} />

                  </React.Fragment>
                  //: 
                  //this.props.page.grafikMaxiMini === 1 ? 
                  // <React.Fragment>

                  //   <Grid
                  //     container spacing={2}
                  //     className={classes.container}
                  //     style={{ width: this.state.windowWidth > 599 ? "calc(100% + -216px)" : "100%", paddingTop: '', margin: "auto" }}
                  //   >
                  //   <Grid
                  //     item xs={12} sm={12}

                  //     style={{ paddingLeft: this.state.windowWidth > 599 ? "10px" : "10px", paddingRight: this.state.windowWidth > 599 ? "8px" : "10px" }}
                  //   >
                  //     <Paper className={classes.paper} elevation={0} >
                  //       <StartNawigacja windowWidth={this.state.windowWidth} />
                  //     </Paper>
                  //   </Grid>
            
                  //   <Grid
                  //       item xs={12} sm={12}
                      
                  //       style={{ paddingLeft: this.state.windowWidth > 599 ? "10px" : "10px", paddingRight: this.state.windowWidth > 599 ? "8px" : "10px" }}
                  //     >
                  //       <Paper id="graphic" className={classes.paper} elevation={0} >
                  //         <CenterPanelMini expanded={this.state.expand} expand={this.expand} windowWidth={this.state.windowWidth} />
                  //       </Paper>
                  //     </Grid>
                  //   </Grid>

                  // </React.Fragment>
                
                : this.props.page.grafikMaxiMini === 1 ?




                < React.Fragment >
 
               


              <Grid
                container spacing={2}
                className={classes.container}
                style={{ width: this.state.windowWidth > 599 ? "calc(100%)" : "100%", paddingTop: '' }}
              >
                  
                <Grid
                  item xs={12} sm={9}
                  className={classes.orderCenter}
                  style={{ paddingLeft: this.state.windowWidth > 599 ? "10px" : "10px", paddingRight: this.state.windowWidth > 599 ? "8px" : "10px" }}
                >
                  <Paper id="nav" className={classes.paperNav} elevation={6} style={{display: this.state.windowWidth > 1095 ? "flex" : "block", justifyContent: "center"}} >
                    {themeExist(color) ?
                      <MuiThemeProvider theme={themeSelect(color)}>
                        <CenterRightMini2 windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} />
                      </MuiThemeProvider>
                      :
                      <CenterRightMini2 windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} />
                    }
                  </Paper>

                  <RoomPanelMini2 windowWidth={this.state.windowWidth} />
                  
                </Grid>


                {this.state.windowWidth > 599 ?
                  (
                    <Grid item xs={12} sm={3} style={{ order: 5, height: "50px" }}>
                      <PanelRight setZarzadzajOpen={this.setZarzadzajOpen} />
                    </Grid>
                  ) : null}

              </Grid>

                  <Grid item className={classes.orderBottom} style={this.state.windowWidth > 599 ? { padding: '8px 8px 8px 8px', width: "calc(75%)" } : { paddingLeft: "10px", width: "100%", paddingRight: "10px" }}>
                    <Paper id="graphic" elevation={0} style={{padding: "8px", borderRadius: "4px", minHeight: "100px"}} >
                      <CenterPanelMini2 expanded={this.state.expand} expand={this.expand} windowWidth={this.state.windowWidth}/>
                    </Paper>
                    {this.state.windowWidth > 599 ?
                     <LogoFooter/> : null}
                  </Grid>

                  
                  <Grid
                  item xs={12} sm={9}
                  className={classes.orderCenter}
                  style={{ paddingLeft: this.state.windowWidth > 599 ? "10px" : "10px", paddingRight: this.state.windowWidth > 599 ? "8px" : "10px" }}
                >
                  <Paper id="nav" className={classes.paperNav} elevation={6} style={{display: this.state.windowWidth > 1095 ? "flex" : "block", justifyContent: "center"}} >   
                  {themeExist(color) ?
                      <MuiThemeProvider theme={themeSelect(color)}>
                        <CenterRightMini2 windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} noFlags />
                      </MuiThemeProvider>
                      :
                      <CenterRightMini2 windowWidth={this.state.windowWidth} expanded={this.state.expand} expand={this.expand} noFlags/>
                    }
                  </Paper>
                </Grid>

                 


              {this.state.windowWidth <= 599 ?
                  (
                    <Grid item xs={12} sm={3} style={{ order: 10, height: "50px" }}>
                      <PanelRight setZarzadzajOpen={this.setZarzadzajOpen} />
                      <LogoFooter />
                    </Grid>
                  ) : null}



              
                

              </React.Fragment>






                 : null}

          </Grid> : null}




            {!this.state.loading && !this.state.error ? 
            <MuiThemeProvider theme={ThemeOrange}>
              {this.state.panel === 1 && CONFIG.hotelKiosk !== "1" ?
                <Fab
                  color={"secondary"}
                  aria-label="map"
                  onClick={() => { this.openMap() }}
                  style={{ height: "40px", bottom: "64px" }}
                  className={classes.fab}
                >
                  <Typography style={{ textTransform: "none", fontSize: "14px", color: "white", lineHeight: "1" }}>
                    {"street view"}
                  </Typography>
                </Fab>
                : null}
              {this.props.page.podstrona ?
               <Fab
               color={"primary"}
               aria-label="map"
               onClick={() => { store.dispatch(Actions.pageState.setPodstrona(0, ""));  }}
               style={{ height: "40px" }}
               className={classes.fab}
             >
               <Typography style={{ textTransform: "none", fontSize: "14px", color: "white" }}>
                <Trans>Back</Trans>
               </Typography>
             </Fab> 
              :

            <Fab
              //color={this.state.panel === 0 ? "primary" : "secondary"}
              color={ this.state.panel === 0 ? "secondary" : "primary"}
              aria-label="map"
              onClick={() => { this.setPanel(this.state.panel === 0 ? 1 : 0) }}
              style={{ height: "40px" }}
              className={classes.fab}
            >
              <Typography style={{ textTransform: "none", fontSize: "14px", color: "white" }}>
                {this.state.panel === 0 ? <Trans>Map</Trans> : <Trans>Back</Trans>}
              </Typography>
            </Fab> 
            }

            </MuiThemeProvider> : null}

            
            <div id="dialog"></div>
            <div id="dialogKlawiatura"></div>
          </MuiThemeProvider>
        </div>


        {this.state.cookiesZaakceptowane ? null :
          (
            <MuiThemeProvider theme={theme}>
              <CookiesFooter />
            </MuiThemeProvider>
          )}


        {this.props.page.contact.opis !== "" ?
          <MuiThemeProvider theme={theme}>
            <ZarzadzajRezerwacja open={this.state.openZarzadzaj} close={this.setZarzadzajClosed} rezerwacja={this.state.nrRezerwacji} telefon={this.state.nrTelefonu} />
          </MuiThemeProvider>
          : null}

        
        
      </React.Fragment> 
    );
  }
}

const styles = (theme: Theme) => ({
  root: {
    margin: "0",
    //minHeight: "100vh",
    //background: `url(${tloUrl})`,
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  },
  container: {
    margin: "0em",
    paddingTop: "0.4em",
    padding: '0em',
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600,
    padding: "9px 14px 9px 0"
  },
  orderRight: {
    "@media (min-width: 600px)": {
      order: 3
    },
    "@media (max-width: 599px)": {
      order: 5
    }
  },
  orderCenter: {
    "@media (min-width: 600px)": {
      order: 4
    },
    "@media (max-width: 599px)": {
      order: 3
    }
  },
  orderBottom: {
    "@media (min-width: 600px)": {
      order: 6
    },
    "@media (max-width: 599px)": {
      order: 4
    }
  },
  paper: {
    //padding: "4px 6px",
    //margin: "4px 4px", 
    //background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
    background: "#fcfcfc",
    //position: "relative" as "relative"
    //padding: "0.4em",
    //background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",

    //backgroundColor : theme.palette.background.default
    //padding: "0px",
    borderRadius: 0,
    height: "100%"
  },
  fab: {
    zIndex: 1000,
    position: "fixed" as "fixed",
    bottom: "15px",
    right: "15px",
  },
  paperNav: {
    padding: "4px 6px",
    background: "white",
    //background: "#fcfcfc",   
    borderRadius: "0px",
    boxShadow: `none`,
    // boxShadow: `0px 0px 2px rgb(0 0 0 / 20%), 
    //                0px 0px 2px rgb(0 0 0 / 14%), 
    //                0px 0px 2px rgb(0 0 0 / 12%)`   
  },
  positionRelative: {
    position: 'relative' as 'relative',
  },
  link: {
    color: "#458B00",
    textDecoration: "none"
  }
});

const mapStateToProps = (state: AppState) => ({
  lang: state.pageState.lang,
  dateFrom: state.pageState.dateFrom,
  showMap: state.pageState.showMap,
  page: state.pageState,
  notifierOpen: state.pageState.notifierOpen,
  rezerwacjaAnuluj: state.pageState.rezerwacjaAnuluj,

});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(App)));
